export default __webpack_public_path__ + "static/media/icon-email-outline.6c3492e0.svg";